const footerLinks = {
  navigation: [
    { label: '热门话题', href: '#topics' },
    { label: '精选推荐', href: '#cards' },
    { label: '最近更新', href: '#updates' },
    { label: '分类索引', href: '#index' },
    { label: '热门排行', href: '#ranking' },
    { label: '精彩视频', href: '#media' },
    { label: '关于我们', href: '#about' },
    { label: '常见问题', href: '#faq' },
  ],
  categories: [
    { label: '韩漫', href: '#index' },
    { label: '日漫', href: '#index' },
    { label: '国漫', href: '#index' },
    { label: '恋爱漫画', href: '#topics' },
    { label: '热血漫画', href: '#topics' },
    { label: '玄幻漫画', href: '#topics' },
  ],
};

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  handleClick('#hero');
                }}
                className="inline-block mb-4"
              >
                <span className="text-2xl font-heading text-background-50 whitespace-nowrap">
                  丫丫漫画
                </span>
              </a>
              <p className="text-sm text-foreground-300 leading-relaxed mt-3 max-w-xs">
                丫丫漫画🌟下拉式翻页在线阅读，👀免费畅享全集漫画，韩漫日漫国漫一应俱全，流畅舒适的阅读体验随时追更。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {footerLinks.navigation.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleClick(link.href);
                      }}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
              <ul className="space-y-2.5">
                {footerLinks.categories.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleClick(link.href);
                      }}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-foreground-400 leading-relaxed">
                更多合作伙伴信息即将上线，敬请期待。
              </p>
              <div className="mt-5">
                <h4 className="text-sm font-semibold text-background-50 mb-3">关注我们</h4>
                <div className="flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 cursor-pointer hover:bg-primary-600 hover:text-background-50 transition-colors duration-200">
                    <i className="ri-wechat-line text-lg"></i>
                  </span>
                  <span className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 cursor-pointer hover:bg-primary-600 hover:text-background-50 transition-colors duration-200">
                    <i className="ri-weibo-line text-lg"></i>
                  </span>
                  <span className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 cursor-pointer hover:bg-primary-600 hover:text-background-50 transition-colors duration-200">
                    <i className="ri-bilibili-line text-lg"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2019-2026 丫丫漫画 版权所有
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-300 transition-colors whitespace-nowrap">隐私政策</span>
              <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-300 transition-colors whitespace-nowrap">服务条款</span>
              <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-300 transition-colors whitespace-nowrap">版权声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}